document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    const topContentSlider = new Swiper('.top-content__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    const sliderSwiper = new Swiper('.slider-swiper',{
        loop: true,
        speed: 600,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.slider-next',
            prevEl: '.slider-prev'
        }
    });

    const highlightsSwiper = new Swiper('.highlights-slider',{
        loop: true,
        speed: 600,
        navigation: {
            nextEl: '.highlights-next',
            prevEl: '.highlights-prev'
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            900:{
                slidesPerView: 3
            }
        }
    });


    const gallerySwiper = new Swiper('.gallery-swiper',{
        loop: true,
        speed: 600,
        centeredSlides: true,
        navigation: {
            nextEl: '.gallery-next',
            prevEl: '.gallery-prev'
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            900:{
                spaceBetween: 34,
                slidesPerView: 2.5
            }
        }
    });
});